exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".knc6OsYQiiv9cEKpcFFjD{position:fixed;top:0;left:0;right:0;bottom:0;background-color:hsla(0,0%,100%,.65)}._3yLLwOJNjMiiQX6I9P35gd{position:fixed;z-index:4;top:20%;left:25%;right:25%;height:320px;background-color:#454579;border-radius:10px}h1._1VbdUO57qnNCOjF669XCA2{font-family:jelly_crazies;text-transform:uppercase;font-size:25px;margin-top:30px;margin-bottom:20px}span._1HCmW3BUqd3OuuUkfaGKkj{position:absolute;top:10px;right:10px;font-size:42px;color:#b3d2fa;cursor:pointer;transition:all .2s;background-color:#322d63;border-radius:50%;width:42px;height:42px}span._1HCmW3BUqd3OuuUkfaGKkj:hover{color:#e3a527}span._1HCmW3BUqd3OuuUkfaGKkj i{transform:scale(1.2)}._3DqeLQ2o9sKC7gp_kYwdWs{margin-top:1em}._3DqeLQ2o9sKC7gp_kYwdWs._3zVjKn1naSw4z09_27e1iA{cursor:default;background-color:#ccc}._3Ep1uUybGRN2FvLWnOK35T{display:inline-block;width:100%;margin-top:.7em;font-size:16px;cursor:pointer}@media screen and (max-width:1000px){._3yLLwOJNjMiiQX6I9P35gd{left:10%;right:10%}}@media screen and (max-width:700px){._3yLLwOJNjMiiQX6I9P35gd{left:0;right:0}h1._1VbdUO57qnNCOjF669XCA2{font-size:15px}span._1HCmW3BUqd3OuuUkfaGKkj{font-size:28px;width:28px;height:28px}}", ""]);

// exports
exports.locals = {
	"overlay": "knc6OsYQiiv9cEKpcFFjD",
	"modal": "_3yLLwOJNjMiiQX6I9P35gd",
	"modalText": "_1VbdUO57qnNCOjF669XCA2",
	"closeModal": "_1HCmW3BUqd3OuuUkfaGKkj",
	"modalBtn": "_3DqeLQ2o9sKC7gp_kYwdWs",
	"disabled": "_3zVjKn1naSw4z09_27e1iA",
	"denyText": "_3Ep1uUybGRN2FvLWnOK35T"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/sass-loader!./src/components/Modals/Modal.scss
 ** module id = 324
 ** module chunks = 0
 **/